export default {
    show: false,
    color: 'success',
    text: 'mensaje'
  }